<script setup lang="ts">
import PageContainer from "~/components/ui/PageContainer.vue";

const textbookAlignedPoints = [
  "Yeh lesson Quaid-e-Azam ke convocation address par based hai aur youth ko newly independent Pakistan ka responsible stakeholder banata hai.",
  "Text ka central stress constructive spirit, responsible citizenship, discipline aur economic self-reliance par hai.",
  "Government job mentality ko criticize karke lesson youth ko commerce, trade, industry aur technical fields ki taraf motivate karta hai.",
];

const chapterCoverage = [
  "Independence as historical transformation",
  "Freedom with responsibility",
  "Constructive spirit in a sovereign state",
  "Colonial education ki criticism",
  "Government-job mentality ka rejection",
  "Trade, commerce, industry aur technical careers",
  "Youth ki nation-building responsibility",
];

const quickRevisionPoints = [
  "Pakistan ki independence ne slavery se freedom ki taraf real transformation create ki.",
  "Freedom ka matlab lawless license nahi, disciplined responsibility hai.",
  "Constructive spirit rebuilding, service aur practical work ka naam hai.",
  "Colonial education ne clerk mentality ko strong kiya tha.",
  "Quaid-e-Azam ne youth ko trade, industry aur technical fields ki taraf motivate kiya.",
  "Nation-building aur economic self-reliance lesson ke linked ideas hain.",
];

const readingQuestions = [
  {
    question: "Why does Quaid-e-Azam call independence a great transformation?",
    answer: "Is liye ke independence ne people ko ruled nation se sovereign nation me convert kar diya. Ab responsibilities bhi un ki apni hain aur future bhi un ke apne decisions aur effort par depend karta hai.",
  },
  {
    question: "How does Quaid-e-Azam describe the transformation that came with the independence of Pakistan?",
    answer: "Quaid-e-Azam batate hain ke Pakistan ki independence ne slavery se freedom ki taraf historical transformation create ki. Ab logon ke paas apni state, apni government aur apni responsibilities hain, is liye unhen is change ke implications samajhne chahiye.",
  },
  {
    question: "What does he mean by constructive spirit in a sovereign state?",
    answer: "Constructive spirit se murad nation-building ke liye positive, disciplined aur productive effort hai. Freedom ke baad sirf struggle ka spirit enough nahi hota; ab rebuilding, development aur service ki zarurat hoti hai.",
  },
  {
    question: "Why is discipline so important in the lesson?",
    answer: "Discipline is liye important hai kyun ke Quaid-e-Azam ke nazdeek free state me progress tabhi hoti hai jab citizens responsible behavior show karen. Without discipline, freedom disorder me badal sakti hai aur nation-building weak ho jati hai.",
  },
  {
    question: "Why does Quaid-e-Azam discourage the pursuit of government service as the sole ambition of graduates?",
    answer: "Woh samajhte hain ke colonial education system ne students ko sirf government jobs ke liye prepare kiya tha. Un ke nazdeek yeh narrow ambition youth ko clerkship mentality me qaid kar deti hai, jab ke business, industry aur technical work me zyada growth aur national benefit hai.",
  },
  {
    question: "How does the criticism of colonial education support the overall message of the lesson?",
    answer: "Is criticism ka purpose youth ko purane slave mindset se nikalna hai. Lesson ka broader message yeh hai ke azad state me graduates ko independent, practical aur economically useful fields me kaam karna chahiye.",
  },
  {
    question: "Why does Quaid-e-Azam give importance to trade, commerce and industry?",
    answer: "Woh in fields ko is liye important samajhte hain kyun ke yeh economy ko strong banate hain aur nation ko self-reliant karte hain. Sirf clerical ya office ambition se mulk ki productive strength barh nahi sakti.",
  },
  {
    question: "What does Quaid-e-Azam mean when he says that freedom does not mean license?",
    answer: "Is ka matlab yeh hai ke freedom ka matlab yeh nahi ke insaan jo chahe kare baghair state ya society ke interests ki parwah kiye. Real freedom discipline aur responsibility ke sath hi meaningful hoti hai.",
  },
  {
    question: "How are youth responsibility and economic self-reliance connected in the lesson?",
    answer: "Quaid-e-Azam ke nazdeek youth ki responsibility sirf speeches tak limited nahi honi chahiye. Jab youth technical education, trade, commerce aur productive careers adopt karti hai to woh apne aap ko bhi strong banati hai aur state ko bhi economically stable karti hai.",
  },
  {
    question: "What practical role does the lesson assign to the youth of Pakistan?",
    answer: "Lesson youth ko disciplined citizenship, productive work, self-reliance aur national service ka role assign karta hai. Unhen sirf degrees lene wale graduates nahi balkeh active builders of the state banna chahiye.",
  },
];

const mcqs = [
  {
    question: "According to the lesson, what should not be the sole ambition of graduates?",
    options: [
      { label: "a", text: "technical education", verdict: "incorrect", reason: "Lesson technical and practical fields ko encourage karta hai." },
      { label: "b", text: "government service", verdict: "correct", reason: "Quaid-e-Azam specifically warns against making government jobs the only ambition." },
      { label: "c", text: "trade and commerce", verdict: "incorrect", reason: "In fields ko lesson positive alternative ke tor par present karta hai." },
      { label: "d", text: "productive industry", verdict: "incorrect", reason: "Industry ko nation-building ke liye useful field bataya gaya hai." },
    ],
  },
  {
    question: "What does Quaid-e-Azam mean by constructive spirit?",
    options: [
      { label: "a", text: "political slogans without practical work", verdict: "incorrect", reason: "Lesson sirf slogans nahi, practical rebuilding aur disciplined effort par focus deta hai." },
      { label: "b", text: "positive and productive effort for national development", verdict: "correct", reason: "Constructive spirit ka central meaning productive nation-building effort hi hai." },
      { label: "c", text: "complete withdrawal from public life", verdict: "incorrect", reason: "Youth ko active citizenship ke liye motivate kiya gaya hai, withdrawal ke liye nahi." },
      { label: "d", text: "freedom from all discipline", verdict: "incorrect", reason: "Chapter repeatedly discipline aur responsibility ko necessary batata hai." },
    ],
  },
  {
    question: "In the lesson, freedom does not mean:",
    options: [
      { label: "a", text: "responsibility", verdict: "incorrect", reason: "Responsibility to freedom ka essential part batayi gayi hai." },
      { label: "b", text: "nation-building", verdict: "incorrect", reason: "Nation-building freedom ke baad youth ka key role hai." },
      { label: "c", text: "license to act without limits", verdict: "correct", reason: "Lesson ka exact idea yahi hai ke freedom ko lawless license samajhna wrong hai." },
      { label: "d", text: "self-reliance", verdict: "incorrect", reason: "Self-reliance ko positive national quality ke tor par present kiya gaya hai." },
    ],
  },
];

const answerBuilding = [
  "Answer me freedom ke baad responsibility barhne ka point zaroor mention karo.",
  "Government jobs wale jawab me colonial education aur clerk mentality ka relation likho.",
  "Constructive spirit ko nation-building, discipline aur self-reliance ke sath connect karna strong answer banata hai.",
  "Trade, commerce aur industry wale answer me economy aur practical nation-building ka relation likho.",
  "Agar question freedom se related ho to `freedom does not mean license` ko zaroor explain karo.",
];

usePageSeo({
  title: "Responsibility of the Youth in Nation-Building Notes | 11th Class English Unit 2",
  description: "11th class English Unit 2 notes with reading answers on youth responsibility, constructive spirit, discipline, freedom with responsibility and self-reliance.",
  keywords: "responsibility of the youth in nation-building notes, 11th class english unit 2, class 11 english chapter 2, youth nation building short questions, quaid e azam convocation address notes",
  breadcrumbs: [
    { name: "Home", item: "/" },
    { name: "11th English", item: "/11th/english/" },
    { name: "Prose", item: "/11th/english/prose/" },
    { name: "Responsibility of the Youth in Nation-Building", item: "/11th/english/prose/responsibility-of-the-youth-in-nation-building/" },
  ],
});
</script>

<template>
  <PageContainer>
    <section class="app-page-stack">
      <header class="app-page-header">
        <p class="app-page-kicker">Unit 2</p>
        <h1 class="app-page-title">Responsibility of the Youth in Nation-Building</h1>
        <p class="app-page-intro">
          Yeh page Quaid-e-Azam ke nation-building message ko exam prep format me organize karta hai. Is unit ka main stress youth ki responsibility aur constructive national role par hai.
        </p>
      </header>

      <section class="english-panel-muted">
        <h2 class="app-section-heading">Textbook-Aligned Snapshot</h2>
        <ul class="app-list">
          <li v-for="item in textbookAlignedPoints" :key="item">{{ item }}</li>
        </ul>
      </section>

      <section class="english-panel">
        <h2 class="app-section-heading">Unit 2 Coverage Checklist</h2>
        <ul class="app-list-grid">
          <li
            v-for="item in chapterCoverage"
            :key="item"
            class="english-mini-card-muted"
          >
            {{ item }}
          </li>
        </ul>
      </section>

      <section class="english-panel-muted">
        <h2 class="app-section-heading">Quick Revision Points</h2>
        <ul class="app-list">
          <li v-for="item in quickRevisionPoints" :key="item">{{ item }}</li>
        </ul>
      </section>

      <section class="english-panel">
        <h2 class="app-section-heading">Reading and Critical Thinking Answers</h2>
        <div class="mt-4 space-y-4">
          <article
            v-for="item in readingQuestions"
            :key="item.question"
            class="english-inner-card-muted"
          >
            <h3 class="app-title-card">{{ item.question }}</h3>
            <p class="app-rich-text mt-3">{{ item.answer }}</p>
          </article>
        </div>
      </section>

      <section class="english-panel">
        <h2 class="app-section-heading">MCQ with Option Explanation</h2>
        <div class="mt-4 space-y-4">
          <article
            v-for="item in mcqs"
            :key="item.question"
            class="english-inner-card-muted"
          >
            <h3 class="app-title-card">{{ item.question }}</h3>
            <ul class="mt-3 space-y-2 text-sm leading-6 text-slate-700 dark:text-slate-300">
              <li v-for="option in item.options" :key="option.label">
                <span class="font-medium text-slate-900">{{ option.label }}. {{ option.text }}</span>
                <span>{{ option.verdict === "correct" ? " Correct:" : " Not correct:" }} {{ option.reason }}</span>
              </li>
            </ul>
          </article>
        </div>
      </section>

      <section class="english-panel">
        <h2 class="app-section-heading">Answer-Building Notes</h2>
        <ul class="app-list">
          <li v-for="item in answerBuilding" :key="item">{{ item }}</li>
        </ul>
      </section>
    </section>
  </PageContainer>
</template>





